var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _rect5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSwitchSite = function SvgSwitchSite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0542 4.87533L37.3378 4.75856",
    stroke: "#4A90FF",
    strokeWidth: 1.90278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4512 1.00001L38.7303 4.87464L34.4512 8.74927",
    stroke: "#4A90FF",
    strokeWidth: 1.90278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3103 48.2147L16.0267 48.332",
    stroke: "#4A90FF",
    strokeWidth: 1.90278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2791 52.0886L14 48.214L18.2791 44.3394",
    stroke: "#4A90FF",
    strokeWidth: 1.90278,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.7819,
    y: 19.8693,
    width: 29.9553,
    height: 16.6822,
    rx: 0.950075,
    stroke: "#4A90FF",
    strokeWidth: 1.90015
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7638,
    y: 29.1603,
    width: 6.06371,
    height: 7.39102,
    rx: 0.950075,
    stroke: "#4A90FF",
    strokeWidth: 1.90015
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3822,
    y: 23.851,
    width: 8.71833,
    height: 4.7364,
    rx: 0.950075,
    stroke: "#4A90FF",
    strokeWidth: 1.90015
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9047,
    y: 14.8503,
    width: 13.0004,
    height: 5.03655,
    rx: 1.1,
    stroke: "#4A90FF",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.405 15.3333V19.6249",
    stroke: "#4A90FF",
    strokeWidth: 1.6,
    strokeLinecap: "square"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8791,
    y: 13.6999,
    width: 4.77109,
    height: 6.18688,
    rx: 1.1,
    stroke: "#4A90FF",
    strokeWidth: 1.6
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwitchSite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/switch-site.43213c38.svg";
export { ForwardRef as ReactComponent };